import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ManualOrder,PagedOrders } from '../models/manual-service.models';
import { environment } from 'src/environments/environment';
import { CitiesService } from '../../cities/services/cities.service';
import { CalculatedOrderRoute } from '../models/manual-service.models';

@Injectable({
  providedIn: 'root'
})
export class ManualServicesServerService {
  private url = `${environment.apiUrl}/services`;

  constructor(private http: HttpClient, private citiesService: CitiesService) {}

 
    createManualOrder(order: ManualOrder): Observable<ManualOrder> {
    const selectedCity = this.citiesService.getUserSelectedCityId();
    const orderWithCity = { ...order, ops_city_id: selectedCity };
    return this.http.post<ManualOrder>(`${environment.apiUrl}/manualServiceCreate`, orderWithCity);
  }

   editOrder(id: number, order: ManualOrder): Observable<ManualOrder> {
    const url = `${this.url}/${id}`;
    return this.http.put<ManualOrder>(url, order);
  }

    getManualOrders(filters: any): Observable<PagedOrders> {
    // Formatear las fechas en el formato YYYY-MM-DD
    const formattedFilters = { ...filters };
    if (formattedFilters.date) {
      formattedFilters.date = new Date(formattedFilters.date).toISOString().split('T')[0];
    }
    if (formattedFilters.from) {
      formattedFilters.from = new Date(formattedFilters.from).toISOString().split('T')[0];
    }
    if (formattedFilters.to) {
      formattedFilters.to = new Date(formattedFilters.to).toISOString().split('T')[0];
    }
  
      const cleanedFilters = Object.keys(formattedFilters)
      .filter((key) => formattedFilters[key] !== null && formattedFilters[key] !== undefined && formattedFilters[key] !== '')
      .reduce((obj, key) => {
        obj[key] = formattedFilters[key];
        return obj;
      }, {});
  
    // Construir el query string
    const queryString = Object.keys(cleanedFilters)
      .map((key) => `${key}=${encodeURIComponent(cleanedFilters[key])}`)
      .join('&');
  
    const finalQueryString = queryString || `filter=all&all_times=True`;
  
   
    return this.http.get<PagedOrders>(`${this.url}?filter=manual&${finalQueryString}`);
  }

   calculateRoute(order: ManualOrder): Observable<CalculatedOrderRoute> {
     
      const url = `${environment.apiUrl}/service_route/calculate`;
      return this.http.post<CalculatedOrderRoute>(url, order);
    }

    getVehicleTypes(): Observable<any[]> {
    
      return this.http.get<any[]>(`${environment.apiUrl}/vehicleTypes`);
    }

    cancelOrder(id: number): Observable<ManualOrder> {
        const url = `${this.url}/${id}?delete_multiple_service_requests=True&delete_in_progress_service=True`;
        return this.http.delete<ManualOrder>(url, {});
      }
}
